export default __webpack_public_path__ + "static/media/location_red_pin.5dc613ff.png";